export default "__VITE_ASSET__DzTgEStE__"